import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { Button, Input, Space, DatePicker, Select, Tooltip } from 'antd';
import _ from 'lodash';

import { Form, InputMask, PageHeader } from '~/components';
import { dataPtBr, formatarData } from '~/helpers/functions';
import { setStorage } from '~/helpers/storage';

import NovoContext from '../NovoContext';
import S from './styles';

const { Option } = Select;

function InformarDados() {
  const history = useHistory();
  const { tipoRequest } = useContext(NovoContext);

  const [contrato, setContrato] = useState({});

  const initialRender = useCallback(() => {
    const data = JSON.parse(sessionStorage.getItem('contrato'));
    setContrato(data);
    sessionStorage.removeItem('novoTemplate');
  }, []);

  useEffect(() => {
    initialRender();
  }, [initialRender]);

  const lidarCampos = (valor, tipo, readOnly) => {
    switch (tipo.toLowerCase()) {
      case 'data':
        return readOnly ? dataPtBr(valor, 'L') : formatarData(valor, 'L');
      case 'datacompleta':
        return readOnly ? dataPtBr(valor, 'LL') : formatarData(valor, 'LL');
      default:
        return valor;
    }
  };

  function copiarCampos(values) {
    const novoContrato = { ...contrato };
    if (!novoContrato.campos) {
      return novoContrato;
    }

    novoContrato.campos = novoContrato.campos.map((campo) => {
      const value = values?.[campo.nome];
      if (typeof value === 'undefined') {
        return campo;
      }

      return {
        ...campo,
        valor: lidarCampos(value, campo.tipo, true),
      };
    });

    return novoContrato;
  }

  async function onFinish(values) {
    const novoContrato = copiarCampos(values);
    setContrato(novoContrato);
    setStorage('contrato', novoContrato, 'session');

    history.push(`/${tipoRequest}/finalizar`);
  }

  const renderOpcoesSelect = (opcoes) => {
    const values = opcoes.split('|');
    return values.map((opcao) => (
      <Option key={opcao} value={opcao}>
        {opcao}
      </Option>
    ));
  };

  function renderInput(tipo, opcoes) {
    switch (tipo) {
      case 'texto':
        return <Input.TextArea rows={3} />;
      case 'percentual':
        return <InputMask.Percent size="large" placeholder="0 %" />;
      case 'moeda':
        return <InputMask.Currency size="large" placeholder="R$ 0,00" />;
      case 'data':
        return <DatePicker className="fullwidth" size="large" format="L" />;
      case 'dataCompleta':
        return <DatePicker className="fullwidth" size="large" format="LL" />;
      case 'cpfCnpj':
        return <InputMask.Document size="large" />;
      case 'selecao':
        return <Select size="large">{renderOpcoesSelect(opcoes)}</Select>;
      default:
        return <Input size="large" />;
    }
  }

  return (
    <>
      {!_.isEmpty(contrato) ? (
        <>
          <PageHeader
            title={contrato.nome}
            extra={
              <Button danger onClick={() => history.push('/home')}>
                Cancelar
              </Button>
            }
          />

          <S.Content>
            <Form layout="vertical" onFinish={onFinish}>
              <Form.Grid columns={2}>
                {contrato.campos &&
                  contrato.campos.map((item) => (
                    <Tooltip title={item.tooltip} key={item.nome}>
                      <Form.Item
                        hasFeedback
                        label={item.nomeExibicao}
                        name={item.nome}
                        initialValue={lidarCampos(item.valor, item.tipo, false)}
                        rules={[
                          { required: true, message: `Por favor, informar ${item.nomeExibicao}` },
                        ]}
                      >
                        {renderInput(item.tipo, item.opcoes)}
                      </Form.Item>
                    </Tooltip>
                  ))}
              </Form.Grid>

              <Form.Footer>
                <Space>
                  {tipoRequest === 'novo' ? (
                    <Button
                      size="large"
                      icon={<ArrowLeftOutlined />}
                      onClick={() => history.push('/novo/tipo-template')}
                    >
                      Voltar
                    </Button>
                  ) : null}

                  <Button
                    className="right-icon"
                    type="primary"
                    htmlType="submit"
                    size="large"
                    icon={<ArrowRightOutlined />}
                  >
                    Avançar
                  </Button>
                </Space>
              </Form.Footer>
            </Form>
          </S.Content>
        </>
      ) : null}
    </>
  );
}

export default InformarDados;
